import { render, staticRenderFns } from "./appointmentRecord.vue?vue&type=template&id=d78951e6&scoped=true&"
import script from "./appointmentRecord.vue?vue&type=script&lang=js&"
export * from "./appointmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./appointmentRecord.vue?vue&type=style&index=0&id=d78951e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78951e6",
  null
  
)

export default component.exports